// extracted by mini-css-extract-plugin
export default {"reset":"KxnsHY","visuallyHidden":"Cwi5nK"};